var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,22.7H5.1c-1.7,0-3.1-1.4-3.1-3.1V9.2c0-1,0.5-2,1.3-2.5l6.9-4.8c1.1-0.7,2.5-0.7,3.5,0l6.9,4.8 c0.8,0.6,1.3,1.5,1.3,2.5v10.4C21.9,21.3,20.6,22.7,18.9,22.7z M12,3.3c-0.2,0-0.4,0.1-0.6,0.2L4.5,8.3C4.2,8.5,4.1,8.8,4.1,9.2 v10.4c0,0.6,0.5,1.1,1.1,1.1h13.7c0.6,0,1.1-0.5,1.1-1.1V9.2c0-0.4-0.2-0.7-0.5-0.9l-6.9-4.8C12.4,3.4,12.2,3.3,12,3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.5b41149547ad4990bce5b2bc2d3075d1.svg";
export { ForwardRef as ReactComponent };